import script from "./LeadCustomerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LeadCustomerModal.vue?vue&type=script&setup=true&lang=js"

import "./LeadCustomerModal.vue?vue&type=style&index=0&id=7ae0ab26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ae0ab26"]])

export default __exports__